import {getCachedTableDataSlice, getCachedTableResultSelector} from 'src/hooks/common-data-service/cached-table';

import {accountSearchResultStateSelector} from './account-search-result-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {AccountSearchCriteria} from 'src/openapi/admin/models/AccountSearchCriteria';
import type {AccountSearchFiltering} from 'src/openapi/admin/models/AccountSearchFiltering';
import type {AccountSortField} from 'src/openapi/admin/models/AccountSortField';

export const accountSearchResultDisabledUsersSlice = getCachedTableDataSlice<
    Record<string, number>,
    AccountSearchCriteria,
    AccountSortField,
    AccountSearchFiltering
>('accountSearchResultDisabledUsers');

export const accountSearchResultDisabledUsersActions = accountSearchResultDisabledUsersSlice.actions;

const accountSearchResultDisabledUsersCacheSelector: CachedTableCacheSelector<Record<string, number>>
    = state => state.accountSearchResult.disabledUsers.cache;
export const accountSearchResultDisabledUsersDataSelector: CachedTableDataSelector<Record<string, number>>
    = state => state.accountSearchResult.disabledUsers;
export const accountSearchResultDisabledUsersResultSelector = getCachedTableResultSelector(
    accountSearchResultDisabledUsersCacheSelector,
    accountSearchResultStateSelector,
);
